import { motion } from "framer-motion";

const experiences = [
  {
    id: 1,
    company: "OrbipayX",
    role: "Mobile Engineer",
    desc: [
      "Engineered the OrbiPayX fintech mobile application — a cross-border money transfer platform supporting CAD–NGN and NGN–CAD currency corridors — using React Native, Expo, and TypeScript.",
      // "Integrated AES-GCM encryption to secure all API payloads end-to-end, ensuring sensitive financial data is fully protected in transit and meeting fintech security standards.",
      // "Architected a custom hooks library on top of TanStack React Query and Axios — covering mutation hooks (create, update, delete) and query hooks (GET) — with built-in payload encryption and decryption on every request and response.",
      "Owned full mobile architecture from project setup through feature delivery, working independently in a fast-moving remote fintech environment.",
    ],
    date: "Oct 2025 - May 2026",
  },
  {
    id: 2,
    company: "Autogon",
    role: "Frontend Engineer",
    desc: [
      // "Designed and engineered the Autogon AI Console end-to-end, collaborating with design and product teams to deliver seamless, high-fidelity user journeys across a complex SaaS platform.",
      "Introduced Redux Toolkit and Zustand for optimised state management, reducing prop-drilling, improving developer velocity, and making the codebase significantly easier to maintain and scale.",
      "Revamped the chatbot CDN frontend, resulting in a 30% increase in user interactions and a 25% improvement in customer satisfaction scores.",
      "Integrated Sentry for proactive error monitoring and alerting, reducing user-reported production issues by 30%.",
    ],
    date: "Feb 2023 - Present",
  },
  {
    id: 3,
    company: "Runshifts",
    role: "Mobile Development Engineer",
    desc: [
      "Led mobile development for Runshifts, a workforce management platform; owned the core shift scheduling and time-tracking interfaces from architecture to delivery.",
      "Built the full UI layer using React Native, Zustand, and TanStack Query — handling complex state, async data flows, and real-time schedule updates.",
      // "Collaborated closely with designers and product managers to iteratively refine the scheduling workflow, improving task clarity and reducing friction for shift workers.",
      // "Established scalable styling architecture using NativeWind and Tailwind CSS, cutting component styling time and ensuring design consistency across screens.",
    ],
    date: "Aug 2024 - Oct 2024",
  },
  {
    id: 4,
    company: "Parahack",
    role: "Frontend Developer",
    desc: [
      "Built and maintained frontend for enterprise-grade web applications, owning features from Figma handoff through to production deployment.",
      // "Introduced react-hook-form and Zod for schema-driven form validation, resulting in a 24% drop in backend error logs and fewer invalid API payloads.",
      "Integrated REST APIs using React Query and Axios, improving data synchronisation, reducing loading states, and increasing UI reactivity across the product.",
    ],
    date: "May 2022 - Feb 2023",
  },
];

const Experience = () => {
  return (
    <section id="experience" className="w-full pt-20 ">
      <div className="mb-12 md:mb-20 flex flex-col justify-start gap-4 border-b border-black/10 dark:border-white/10 pb-8">
        <span className="text-[13px] md:text-sm font-mono text-black/50 dark:text-white/50 uppercase tracking-widest">
          Experience
        </span>
        <h2 className="text-sm sm:text-md md:text-base font-display font-medium tracking-[-0.02em] leading-tight text-black dark:text-white max-w-2xl">
          Where I've engineered impact.
        </h2>
      </div>

      <div className="flex flex-col w-full lg:max-w-4xl xl:max-w-5xl mx-auto">
        {experiences.map((exp, i) => (
          <motion.div
            key={exp.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{
              duration: 0.6,
              delay: i * 0.1,
              ease: [0.16, 1, 0.3, 1],
            }}
            className="w-full py-10 md:py-12 border-b border-black/10 dark:border-white/10 transition-colors duration-500 box-content"
          >
            <div className="flex flex-col md:flex-row items-start justify-between gap-8 md:gap-16">
              {/* Left: Meta */}
              <div className="w-full md:w-1/4 flex flex-row md:flex-col justify-between items-start gap-4">
                <span className="font-mono text-xs text-black/60 dark:text-white/60 uppercase tracking-widest transition-colors duration-300">
                  {exp.date}
                </span>
              </div>

              {/* Right: Content */}
              <div className="w-full md:w-3/4 flex flex-col">
                <div className="flex flex-col mb-4">
                  <h3 className="text-2xl md:text-3xl font-display font-medium tracking-tight text-black dark:text-white">
                    {exp.company}
                  </h3>
                  <span className="text-[13px] font-mono text-black/50 dark:text-white/50 mt-1">
                    {exp.role}
                  </span>
                </div>

                <div className="grid grid-cols-1 gap-4 mt-4">
                  {exp.desc.map((point, idx) => (
                    <div key={idx} className="flex items-start gap-4">
                      <span className="font-mono text-black/20 dark:text-white/20 mt-1">
                        {"—"}
                      </span>
                      <p className="text-[13px] md:text-sm text-black/60 dark:text-white/60 leading-relaxed font-sans max-w-2xl">
                        {point}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
